export class ExtSysConfiguration {
  disabledWriteActions = false
  disableAllActions = false
  disableUntil?: Date = undefined
  disableFrom?: Date = undefined
  disableText = 'Technical shutdown'
  isDisabledUntilPresentCache?: boolean

  public isWriteDisabled() {
    return this.disabledWriteActions && !this.isDisabledUntilExpired()
  }

  public isAllDisabled() {
    return this.disableAllActions && !this.isDisabledUntilExpired()
  }

  public isDisabledUntilExpired() {
    if (typeof this.isDisabledUntilPresentCache !== 'boolean') {
      this.isDisabledUntilPresentCache =
        (this.disableUntil && this.disableUntil.getTime() < Date.now()) ||
        (this.disableFrom && this.disableFrom.getTime() > Date.now())
    }

    return this.isDisabledUntilPresentCache
  }
}
